import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons/faChevronDown';
import React, { useCallback, useState } from 'react';

import { QBox, QButton, QMenu, QMenuItem, QText } from '@captivateiq/quotient';

import type { ModelOption } from '../config/modelConfig';
import { ALL_MODELS, DEFAULT_MODEL } from '../config/modelConfig';

type ModelSelectorProps = {
  selectedModel: ModelOption;
  onModelChange: (model: ModelOption) => void;
};

export const ModelSelector = ({ selectedModel, onModelChange }: ModelSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const handleToggle = useCallback((event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl((prev) => (prev ? null : event.currentTarget));
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSelect = useCallback(
    (model: ModelOption) => {
      onModelChange(model);
      setAnchorEl(null);
    },
    [onModelChange],
  );

  return (
    <>
      <QButton
        data-testid="model-selector-trigger"
        endIcon={faChevronDown}
        size="small"
        variant="outlined"
        onClick={handleToggle}
      >
        {selectedModel.label}
      </QButton>
      <QMenu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
        {ALL_MODELS.map((model) => (
          <QMenuItem
            chip={model.id !== DEFAULT_MODEL.id ? 'Dev' : undefined}
            data-testid={`model-option-${model.id}`}
            key={model.id}
            leftIcon={selectedModel.id === model.id ? faCheck : undefined}
            onClick={() => handleSelect(model)}
          >
            <QBox>
              <QText sx={{ fontSize: '13px', fontWeight: selectedModel.id === model.id ? 600 : 400 }}>
                {model.label}
              </QText>
              <QText sx={{ fontSize: '11px', color: 'grey.500' }}>{model.description}</QText>
            </QBox>
          </QMenuItem>
        ))}
      </QMenu>
    </>
  );
};
